export enum CartActionTypes {
    GETDISCOUNT_REQUEST = '@@Cart/GETDISCOUNT_REQUEST',
    GETDISCOUNT_SUCCESS = '@@Cart/GETDISCOUNT_SUCCESS',
    GETDISCOUNT_ERROR = '@@Cart/GETDISCOUNT_ERROR'
}

export interface CartUIState {
    readonly processing: boolean
    readonly processState: number
    readonly errors?: string []
    readonly data: any
}
